export default "__VITE_ASSET__Dk93AoEs__"